import { APP } from "@constants/app.constants";
const { STATUS } = APP;

export const getEditUserFormInputs = (roles, initialValues) => [
  {
    type: "TEXT",
    label: "Name",
    id: "name",
    name: "name",
    value: initialValues?.name || "",
    placeholder: "Enter the Name",
    validations: [
      {
        type: "REQUIRED",
        message: "Name is required !",
      },
    ],
  },
  {
    type: "TEXT",
    label: "Email Id",
    id: "email",
    name: "email",
    value: initialValues?.email || "",
    placeholder: "Enter the Email Id",
    validations: [
      {
        type: "REQUIRED",
        message: "Email id is required !",
      },
    ],
  },
  {
    type: "TEXT",
    label: "User Name",
    id: "username",
    name: "username",
    value: initialValues?.username || "",
    placeholder: "Enter the User Name",
    validations: [
      {
        type: "REQUIRED",
        message: "User Name is required !",
      },
    ],
  },
  {
    type: "TEXT",
    label: "Password",
    id: "password",
    name: "password",
    value: initialValues?.password || "",
    placeholder: "Enter the Password",
    validations: [],
  },

  {
    type: "AUTOCOMPLETE",
    label: "Role",
    id: "roleId",
    name: "role_id",
    options: roles,
    value: initialValues?.roleId || "",
    isMultiple: true,
    placeholder: "Select Role",
    validations: [
      {
        type: "REQUIRED",
        message: "Role is required !",
      },
    ],
  },
];
